import React from "react";
import { useForm } from "react-hook-form";

const MobileVerifyOtpForm = ({ form, onSubmit, email, otp }) => {
	const { register, handleSubmit, formState, setValue } = form;

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<p className="font-medium text-[24px] leading-[100%] font-[Montserrat] text-center text-[#193D34] mb-[20px]">
				We've sent a verification code to
			</p>
			<p className="font-medium text-[16px] leading-[100%] font-[Montserrat] text-center text-oliveGreen mb-[20px]">
				{email || "test@user.com"}
			</p>
			<p className="font-medium text-[18px] leading-[100%] font-[Montserrat] text-center text-[#193D34] mb-[20px]">
				Please enter it below to reset your password.
			</p>
			<div className="w-full">
				<label
					htmlFor="verification-code-mobile"
					className="block text-sm font-medium text-gray-700 mb-1"
				>
					Enter Verification Code
				</label>
				<div className="relative h-[33px]">
					<div className="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
						<img
							src="/assets/verify-otp/img.svg"
							alt="icon"
							className="w-4 h-4"
						/>
					</div>
					<input
						id="verification-code-mobile"
						type="number"
						{...register("otp")}
						placeholder="Enter verification code"
						className="no-spinner w-full h-full rounded-[8px] border border-[#193D34] pl-8 pr-10 p-[8px] outline-none"
					/>
					{otp && (
						<button
							type="button"
							onClick={() => setValue("otp", "")}
							className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-800"
						>
							×
						</button>
					)}
				</div>
				{formState.errors.otp && (
					<p className="text-red-500 text-xs mt-1">
						{formState.errors.otp.message}
					</p>
				)}
			</div>
		</form>
	);
};

export default MobileVerifyOtpForm;
